import { render, staticRenderFns } from "./ProjectFiches.vue?vue&type=template&id=6e2a0b9a"
import script from "./ProjectFiches.vue?vue&type=script&lang=ts"
export * from "./ProjectFiches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports